import { render } from "./LeftMenu.vue?vue&type=template&id=3d6785b8"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=3d6785b8&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Downloads\\放射小程序\\后台\\manager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__